import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { API_BASE_URL, APP_ENV, IS_PRODUCTION } from '@/lib/config'
import log, { isDebugEnabled } from '@/lib/logger'

// Banner de boot: primeira coisa a checar ao depurar em produção.
log.info('boot', 'Faturamento PRECISA', {
  modo: APP_ENV,
  producao: IS_PRODUCTION,
  apiBaseURL: API_BASE_URL,
  origem: window.location.origin,
  rota: window.location.pathname,
  temToken: !!localStorage.getItem('faturamento.token'),
  debug: isDebugEnabled(),
})
log.debug('boot', 'Para desligar estes logs: FaturamentoDebug.off()')

// Erros não tratados também vão para o console com contexto.
window.addEventListener('error', (e) => {
  log.error('window', 'Erro não tratado', { message: e.message, source: e.filename, line: e.lineno })
})
window.addEventListener('unhandledrejection', (e) => {
  log.error('window', 'Promise rejeitada sem tratamento', e.reason)
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
